import Image from 'next/image';

import { Card, Typography, CardActions, Stack } from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';

import Skeleton from './CustomSkeleton.component';

const CardStyled = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 8,
  boxShadow: theme.customShadows.boxShadow2,

  '&:hover': {
    cursor: 'progress',
  },
}));

const CardContentStyled = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  marginBottom: theme.spacing(6),
  overflow: 'visible',
  padding: theme.spacing(4),
}));

const CardActionsStyled = styled(CardActions)(({ theme }) => ({
  paddingBottom: theme.spacing(6),
}));

const BookInfoContainer = styled('div')(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  minHeight: theme.spacing(6),
  justifyContent: 'space-between',
  margin: `${theme.spacing(1)} 0`,
}));

const CategoryLinkContainer = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const CardSkeleton = () => {
  const theme = useTheme();

  return (
    <CardStyled>
      <div>
        <Image
          layout="responsive"
          height="264"
          width="374"
          sizes="50vw"
          src="/static/images/imageCoverSkeleton.png"
          alt="imageCover skeleton"
          loading="lazy"
        />
      </div>
      <CardContentStyled sx={{ height: '128px' }}>
        <Typography>
          <Skeleton variant="text" height={30} />
        </Typography>
        <Stack mt={2}>
          <BookInfoContainer>
            <Skeleton variant="text" height={30} width={95} />
            <Skeleton variant="text" height={30} width={60} />
          </BookInfoContainer>

          <CategoryLinkContainer noWrap>
            <Skeleton variant="text" height={20} width={190} />
          </CategoryLinkContainer>
        </Stack>
      </CardContentStyled>
      <CardActionsStyled>
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{
            borderRadius: theme.shape.borderRadius * 8,
            bgcolor: '#F2F6FF',
            margin: '0 auto',
            width: '95%',
          }}
        />
      </CardActionsStyled>
    </CardStyled>
  );
};

export default CardSkeleton;
